export default __webpack_public_path__ + "static/media/mysqllogo-2.a04abbf7.png";